export default __webpack_public_path__ + "static/media/IN500_logo.00a5fb41.png";